import styled from 'styles/styled';

/* ---------- Layout ---------- */

export const Wrap = styled.div`
  width: calc(100% - 50px);
  height: 100%;
  float: right;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  @media (max-width: 720px) {
    width: calc(100% - 45px);
  }
`;

export const TabStrip = styled.div`
  display: flex;
  gap: 14px;
  border-bottom: 1px solid #2A2E34;
  margin-bottom: 8px;
`;

export const TabBtn = styled.button`
  background: transparent;
  border: none;
  appearance: none;
  cursor: pointer;
  color: #7A7E8C;
  font-size: 12px;
  font-weight: 500;
  padding: 6px 0;
  border-bottom: 2px solid transparent;
  transition: color 120ms ease, border-color 120ms ease;
  &.active {
    color: #EFEFEF;
    font-weight: 700;
    border-bottom-color: #52D381;
  }
`;

export const ListWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding-right: 2px;
`;

export const EmptyState = styled.div`
  text-align: center;
  font-size: 12px;
  color: #7A7E8C;
  padding: 24px 12px;
`;

export const Load = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
  font-weight: 700;
  font-size: 14px;
  color: #EFEFEF;
`;

export const LoadWrap = styled.div`
  display: block;
  width: 32px;
  height: 32px;
  animation: rotation 800ms infinite linear;
  border-radius: 999px;
  box-shadow: 1px 1px 0 1px #52D381;
  margin-bottom: 12px;
  @keyframes rotation {
    from { transform: rotate(0deg); }
    to   { transform: rotate(359deg); }
  }
`;

/* ---------- Trade history item ---------- */

export const TradeItem = styled.div`
  background: #15191E;
  border-radius: 10px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TradeHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const PairName = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #EFEFEF;
  letter-spacing: 0.02em;
`;

export const TypePill = styled.span<{ $tone: 'bull' | 'bear' }>`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 3px 8px;
  border-radius: 999px;
  ${p =>
    p.$tone === 'bull'
      ? `background: rgba(82,211,129,0.12); color: #52D381;`
      : `background: rgba(255,103,130,0.12); color: #FF6782;`}
`;

export const TradeBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  align-items: baseline;
`;

export const L = styled.span`
  font-size: 11px;
  color: #7A7E8C;
  text-align: right;
  font-weight: 400;
  white-space: nowrap;
`;

export const V = styled.span`
  font-size: 12px;
  color: #EFEFEF;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  text-align: left;
  &.bull { color: #52D381; }
  &.bear { color: #FF6782; }
  &.muted { color: #A7A8B2; font-weight: 500; }
`;

export const TimeText = styled.span`
  font-size: 10px;
  color: #7A7E8C;
  font-weight: 400;
  white-space: nowrap;
`;

/* ---------- Asset performance ---------- */

export const AssetItem = styled.div`
  background: #15191E;
  border-radius: 10px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AssetHead = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
`;

export const AssetName = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #EFEFEF;
  letter-spacing: 0.02em;
`;

export const AssetValue = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #EFEFEF;
  font-variant-numeric: tabular-nums;
`;

export const AssetBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
